import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetChartSection,
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { WorksheetRootComponent } from '../../../Core/types';
import { PortionDebugViewButton } from '../../Components';
import { getNumberOfSeparations, getSeparationPath } from '../../Helpers';
import {
  PortionSievingSection,
  SeparationSection,
  SievingPreparationSection,
  SpecimenPreparationSection,
  TestPreparationSection,
} from './Sections';
import {
  ResultsCalculatedPropertiesSection,
  ResultsChartOptionsSection,
  ResultsMessagesSection,
  ResultsReportOptionsSection,
} from './Sections/Results';

const isDevMode = process.env.REACT_APP_ENABLE_DEV_MODE === 'true';
const qestIds = [ids.psdSieveAnalysis.ASTM_C136.rev2019];

let PsdSieveAnalysisAstmC136Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const separationCount = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations));

  return (
    <>
      {isDevMode && (
        <PageSection>
          <PortionDebugViewButton />
        </PageSection>
      )}
      <PageSection heading="Test Preparation">
        <TestPreparationSection />
      </PageSection>
      <PageSection heading="Specimen Preparation">
        <SpecimenPreparationSection />
      </PageSection>
      <PageSection heading="Sieve Portion Preparation">
        <SievingPreparationSection />
      </PageSection>

      {Array(separationCount)
        .fill(undefined)
        .map((_, i) => [
          <PageSection
            key={`sieve_${i}`}
            heading={`${i === 0 ? 'Coarse ' : ''}Portion${separationCount > 1 ? ` ${i + 1}` : ''} Sieving`}
          >
            <NamePrefixModifier appendNamePrefix={`${getSeparationPath(i)}.CoarsePortion`}>
              <PortionSievingSection />
            </NamePrefixModifier>
          </PageSection>,
          <PageSection key={`separation_${i}`} heading={`Separation${separationCount > 1 ? ` ${i + 1}` : ''}`}>
            <SeparationSection index={i} />
          </PageSection>,
        ])}
      {separationCount > 0 && (
        <>
          <NamePrefixModifier appendNamePrefix={`${getSeparationPath(separationCount - 1)}.FinePortion.Subspecimen`}>
            <PageSection heading={`Fine Portion Sieving`}>
              <PortionSievingSection />
            </PageSection>
          </NamePrefixModifier>
        </>
      )}

      {separationCount === 0 && (
        <>
          <NamePrefixModifier appendNamePrefix={`WholePortion`}>
            <PageSection heading={`Portion Sieving`}>
              <PortionSievingSection />
            </PageSection>
          </NamePrefixModifier>
        </>
      )}

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsChartOptionsSection />
        <NamePrefixModifier namePrefix="chart">
          <WorksheetChartSection wide />
        </NamePrefixModifier>
        <ResultsMessagesSection />
        <ResultsCalculatedPropertiesSection />
        <ResultsReportOptionsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

PsdSieveAnalysisAstmC136Worksheet = withInjectedProps(PsdSieveAnalysisAstmC136Worksheet);
PsdSieveAnalysisAstmC136Worksheet.qestIds = qestIds;

export default PsdSieveAnalysisAstmC136Worksheet;
export { PsdSieveAnalysisAstmC136Worksheet };
